import { ErrorBoundary } from "@vyne-shared/components/ErrorBoundary";
import { NarrowPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Result } from "antd";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

const RootComponent = () => (
    <ErrorBoundary>
        <Outlet />
        <TanStackRouterDevtools />
    </ErrorBoundary>
);

export const Route = createRootRoute({
    component: RootComponent,
    notFoundComponent: () => (
        <NarrowPageContentContainer>
            <Result status="404" title="Not found" subTitle="We couldn't find the page you're looking for." />
        </NarrowPageContentContainer>
    ),
});
